import * as Yup from 'yup';

export const customSIPHeaderValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Name is required')
        .max(10, 'Name must be 10 characters or less'),
    suffix: Yup.string()
        .required('Suffix is required')
        .matches(
            /^[A-Z0-9]+$/,
            'Suffix must contain only uppercase letters and numbers',
        )
        .matches(/^\S+$/, 'Suffix must not contain spaces')
        .max(56, 'Suffix must be 56 characters or less'),
    customHeaderTypeID: Yup.string().required('Type is required'),
    linkID: Yup.string().required('Link Object Name is required'),
    value: Yup.string()
        .required('Value is required')
        .matches(
            /^[a-zA-Z0-9[\]. ]*$/,
            'Value must contain only alphanumeric characters and square brackets',
        )
        .max(100, 'Value must be 100 characters or less'),
    visibleScope: Yup.number().required('Visible Scope is required'),
    updateScope: Yup.number().required('Update Scope is required'),
});
